import Crud from '../components/Domains/Crud.vue'
import Add from '../components/Domains/Add.vue'
import Edit from '../components/Domains/Edit.vue'
import View from '../components/Domains/View.vue'
import DomainUserAdd from '../components/Domains/Users/Add.vue'

let routes = {
    path: '/domains',
    component: resolve => require(['../components/layout/AdminApp'], resolve),
    children: [
      {
        path: '/domains',
        name: 'Clientes',
        component: Crud
      },
      {
        path: '/domains/add',
        name: 'Novo Domínio',
        component: Add
      },
      {
        path: '/domains/edit/:id',
        name: 'Editar Domínio',
        component: Edit
      },
      {
        path: '/domains/view/:id',
        name: 'Visualizar Domínio',
        component: View
      },
      {
        path: '/domains/view/domains/:id/users/add',
        name: 'Visualizar Domínio',
        component: DomainUserAdd
      },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/domains.js